import type { BlogPostType } from "../types";
import Post from "./post";

interface BlogPostsProps {
  posts: BlogPostType[];
}

export default function BlogPosts({ posts }: BlogPostsProps) {
  return (
    <section className="container pt-20 md:pt-[150px]">
      <div className="flex flex-col gap-[25px] md:flex-row">
        {posts.map((post) => (
          <Post key={post.id} {...post} />
        ))}
      </div>
    </section>
  );
}
